import { Assets } from '@timeflies/static-assets';
import { createAudioContext } from '../utils/create-audio-context';
var _a = createAudioContext({
    contextsNamePrefix: 'Music',
    storageAudioVolumeKeyPrefix: 'music',
    defaultAudioVolume: 0.2,
    assets: Assets.musics,
    loop: true
}), MusicContextProvider = _a.AudioContextProvider, musicContextList = _a.contextList, useMusicContext = _a.useAudioContext, useMusicVolumeContext = _a.useAudioVolumeContext, useMusicVolumeDispatch = _a.useAudioVolumeDispatch, useMusicCurrentContext = _a.useAudioCurrentContext, useMusicCurrentDispatch = _a.useAudioCurrentDispatch, getNextMusic = _a.getNextAudio;
export { MusicContextProvider, musicContextList, useMusicContext, useMusicVolumeContext, useMusicVolumeDispatch, useMusicCurrentContext, useMusicCurrentDispatch, getNextMusic };
